import { InjectionToken } from '@angular/core';
import { IProfileService } from '../interfaces/external-service/profile-service';

export const EXTERNAL_PROFILE_SERVICE = new InjectionToken<IProfileService>('EXTERNAL_PROFILE_SERVICE');
